
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tour/[travelSlug]",
      function () {
        return require("private-next-pages/tour/[travelSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tour/[travelSlug]"])
      });
    }
  